export function countStudents(students: number[]): string {
	let res = "";
	const grade = ["小学生", "中学生", "高校生"];
	let total = 0;
	const sum = students.reduce(function (acc, num) {
		return acc + num;
	}, 0);
	students.forEach(
		(numGrade, index) => (
			(total += numGrade),
			(res +=
				numGrade !== 0
					? `${grade[index]}${numGrade}人${total < sum ? "、" : ""}`
					: "")
		),
	);
	return res;
}

export function studentsToGrades(students: number[]): string[] {
	const grades: string[] = [];
	students.forEach((num, index) => {
		for (let i = 0; i < num; i++) {
			switch (index) {
				case 0:
					grades.push("小学生");
					break;
				case 1:
					grades.push("中学生");
					break;
				case 2:
					grades.push("高校生");
					break;
			}
		}
	});
	return grades;
}
